import { NavLink } from "@/components/NavLink";
import { ArrowRight } from "lucide-react";

interface LinkItem {
  // Support both naming patterns
  to?: string;
  href?: string;
  label?: string;
  text?: string;
}

interface InternalLinksProps {
  title?: string;
  links: LinkItem[];
}

export const InternalLinks = ({ title = "Related Resources", links }: InternalLinksProps) => {
  return (
    <div className="bg-accent/20 rounded-lg p-6">
      <h3 className="font-semibold mb-4">{title}</h3>
      <ul className="space-y-2">
        {links.map((link, index) => {
          const linkTo = link.to || link.href || "";
          const linkLabel = link.label || link.text || "";
          
          return (
            <li key={index}>
              <NavLink 
                to={linkTo} 
                className="text-primary hover:underline flex items-center gap-2"
              >
                <ArrowRight className="h-4 w-4" />
                {linkLabel}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
